/**
 * "This link belongs to a practice that has left Teamio" — the one place the frontend recognises it.
 *
 * ── Why (2026-11-03, design: docs/plans/2026-11-03-deactivated-site-links-design.md) ──────────────────
 * When a site is deactivated, the purge deletes its short links (form, wiki, booking). Every later tap — a patient on an old
 * text, Google re-checking a practice's listing — then looks like a 404/410, and Lumigo pages Slack for each one even though
 * nothing is wrong. The backend will answer such a link with a NORMAL 200 and this body instead of an error, so there is no
 * alert, and the page can say something clearer than "link not found".
 *
 *   HTTP 200   { type: 'site-inactive' }
 *
 * This file is the contract's frontend half and ships FIRST: until a backend returns it, nothing changes. An old bundle that
 * receives it would not understand it, which is exactly why the backend waits for this to be live.
 *
 * Pure, ZERO imports: cypress/node-tests/site-inactive-link.test.js executes this exact file.
 */

export const SITE_INACTIVE_TYPE = 'site-inactive';

/** True for the 200 answer that means "the practice behind this link is no longer on Teamio". Never throws. */
export function isSiteInactiveResponse(res) {
  return !!res && res.status === 200 && !!res.data && typeof res.data === 'object' && res.data.type === SITE_INACTIVE_TYPE;
}
